import styled from "@emotion/styled"
import { get } from "lodash"
import React from "react"
import tw from "twin.macro"
import tailwindConfig from "../utils/tailwindConfig"
import Picture from "./Picture"
import Slider from "./Slider"

const breakpoints = tailwindConfig.theme.screens

const AwardsBlock = ({ block, contrastText }) => {
  const awards = get(block, "elements.awards.value")
  return (
    <Slider
      slidesToShow={4}
      slidesToScroll={4}
      dots={false}
      mobileFirst={true}
      responsive={[
        {
          breakpoint: parseInt(breakpoints.lg, 10) - 1,
          settings: { slidesToScroll: 3, slidesToShow: 3 },
        },
        {
          breakpoint: parseInt(breakpoints.md, 10) - 1,
          settings: { slidesToScroll: 2, slidesToShow: 2 },
        },
        {
          breakpoint: parseInt(breakpoints.sm, 10) - 1,
          settings: { slidesToScroll: 1, slidesToShow: 1 },
        },
      ]}
    >
      {awards.map(award => {
        const id = get(award, "system.id")
        return <Award award={award} key={id} />
      })}
    </Slider>
  )
}

export default AwardsBlock

const StyledAward = styled.div`
  ${tw`w-full text-center px-6`}
`
const Heading = styled.div`
  ${tw`uppercase text-xl font-bold text-teal`}
`
const ImageWrapper = styled.div`
  ${tw`mx-auto max-w-full`}
  width: 150px;
`

const Text = styled.div`
  ${tw`uppercase text-base font-bold text-blue`}
`

const Award = ({ award }) => {
  const image = get(
    award,
    "elements.image.value[0].elements.image.value[0]"
  )
  const imageAltText = get(
    award,
    "elements.image.value[0].elements.alt_text.value"
  )
  const heading = get(award, "elements.heading.value")
  const text = get(award, "elements.text.value")

  return (
    <StyledAward>
      <ImageWrapper>
        <Picture
          image={image}
          alt={imageAltText}
          cropWidth={150}
          cropRatio={1}
        />
      </ImageWrapper>
      <Heading>{heading}</Heading>
      <Text>{text}</Text>
    </StyledAward>
  )
}
